import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { alertActions } from "../../../actions";
import { MyAccountService } from "../../../services";
import { BookingDetailsService } from "../../../services";
import { StandardService } from "../../../services";

const useCartPage = (t, displayRazorpay) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [cartData, setCartData] = useState([]);
  const [loader, setLoader] = useState("loading");
  // const [loading, setLoader] = useState("notset");
  const [editing, setEditing] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [removeRooms, setRemoveRooms] = useState(false);
  const [current, setcurrent] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [calculatedRoomCharge, setCalculatedRoomCharge] = useState(0);
  const [calculatedTaxgst, setCalculatedTaxgst] = useState(0);
  const [calculatedTotalAmt, setCalculatedTotalAmt] = useState(0);
  const [singleViewDetails, setSingleViewDetails] = useState("");
  const [singleRoom, setSingleRoom] = useState("");
  const [totalingGst, setTotalingGst] = useState("");
  const [totalingRoomCharge, setTotalingRoomCharge] = useState("");
  const [extractedData, setExtractedData] = useState("");
  const [roomChangeSelectedValue, setRoomChangeSelectedValue] = useState();
  const [roomSelectedIndex, setRoomSelectedIndex] = useState();
  const [totalRoomCrtCharge, setTotalRoomCrtCharge] = useState();
  const [totalGstCrtCharge, setTotalGstCrtCharge] = useState();
  const [totalPayableCrtAmount, setTotalPayableCrtAmount] = useState();
  const [request, setRequest] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  let mydata = [];

  const user_id = useSelector((state) => state?.userData?.user?._id);
  const user_name = useSelector((state) => state?.userData?.user?.name);
  const user_email = useSelector((state) => state?.userData?.user?.email);
  const user_phone = useSelector((state) => state?.userData?.user?.phone);

  const [selectedAdults, setSelectedAdults] = useState();
  const [selectedChilren, setSelectedChildren] = useState();
  const [selectedChilrenAbove8, setSelectedChildrenAbove8] = useState();
  useEffect(() => {
    const dddddd = calculateDifference(
      singleRoom.arrival_date,
      singleRoom.departure_date
    );

    // const adultsArray = singleRoom?.rooms?.map((list) => list?.adults);
    // const filteredArray = adultsArray?.filter(
    //   (_, index) => index % dddddd === 0
    // );

    // const adultsArray = singleRoom?.rooms
    //   ?.filter((room) => room.roomTypeId === listss.roomTypeId)
    //   ?.map((filteredRoom) => filteredRoom.adults);

    // const filteredArray = adultsArray?.filter(
    //   (_, index) => index % dddddd === 0
    // );
    // if (filteredArray) {
    //   setSelectedAdults(filteredArray);
    // }

    // console.log(
    //   singleRoom?.rooms?.map((list) => list.adults),
    //   "selectedAdults",
    //   dddddd
    // );
    console.log(singleRoom, "singleRoomsingleRoom");
    setExtractedData(
      singleRoom?.rooms?.map(
        ({ adults, bookingId, roomTypeId, room_type, infantsUnder8 }) => ({
          adults,
          bookingId,
          roomTypeId,
          room_type,
          infantsUnder8,
        })
      )
    );
  }, [singleRoom]);

  const handleChangeRequest = (event) => {
    setRequest(event.target.value);
    console.log(event.target.value); // Logs the input in real-time
  };

  const deleteCartRoom = (roomIndex, ii, singleViewDetails) => {
    setLoader("loading");
    // console.log("roomIndex", ii);
    // console.log(extractedData, "extractedData");

    console.log(
      extractedData,
      roomIndex,
      ii,
      singleRoom,
      singleViewDetails.roomTypeId
    );

    const differnce = calculateDifference(
      singleRoom.arrival_date,
      singleRoom.departure_date
    );

    const matchedItems = extractedData
      .filter(
        (item) =>
          item.roomTypeId === singleViewDetails.roomTypeId && item.adults === ii
      )
      .slice(0, differnce);
    const bookingIds = matchedItems.map((item) => item.bookingId);

    console.log(bookingIds);

    MyAccountService.deleteCartBooking(bookingIds, cartData?.data?.[0].cartId)
      .then((res) => {
        if (res?.data?.status?.code === 0) {
          setPageCount(res?.data?.data?.totalPages);
          setRemoveRooms(false);
          getBookingHistory();
          dispatch(alertActions.success(res?.data?.status?.message));
          // setLoader("isfull");
          window.location.reload();
        } else {
          setLoader("isfull");
          setRemoveRooms(false);
          dispatch(alertActions.error(res?.data?.status?.message));
        }
      })
      .catch((error) => {
        setLoader("isfull");
        setRemoveRooms(false);
        console.log("Errorreg", error);
      });
  };

  const handleChangeChildren = (e, roomIndex) => {
    const dddddd = calculateDifference(
      singleRoom.arrival_date,
      singleRoom.departure_date
    );

    const startIndex = dddddd * roomIndex;
    const updatedData = [...extractedData];
    for (let i = startIndex; i < startIndex + dddddd; i++) {
      if (i < updatedData.length) {
        updatedData[i].infantsUnder8 = Number(e.target.value);
      }
    }
    console.log(
      e.target.value,
      "handleChangeChildren",
      roomIndex,
      extractedData
    );
    const newSelectedChildren = [...selectedChilren];
    newSelectedChildren[roomIndex] = Number(e.target.value);
    console.log(newSelectedChildren, "selectedChilren"); // Update the value for the specific room
    setSelectedChildren(newSelectedChildren);
  };

  const handleChangeRooms = (e, roomIndex) => {
    const dddddd = calculateDifference(
      singleRoom.arrival_date,
      singleRoom.departure_date
    );

    const startIndex = dddddd * roomIndex;
    const updatedData = [...extractedData];
    for (let i = startIndex; i < startIndex + dddddd; i++) {
      if (i < updatedData.length) {
        updatedData[i].adults = Number(e.target.value);
      }
    }
    setExtractedData(updatedData);
    const adultsArray = updatedData?.map((list) => list?.adults);
    const filteredArray = adultsArray?.filter(
      (_, index) => index % dddddd === 0
    );
    console.log(singleRoom, filteredArray, "filteredArray");

    const transformedData = filteredArray?.map((item, index) => ({
      adult_count: item,
      number: index + 1,
    }));

    setRoomChangeSelectedValue(e.target.value);
    setRoomSelectedIndex(roomIndex);
    const newSelectedAdults = [...selectedAdults];
    newSelectedAdults[roomIndex] = Number(e.target.value); // Update the value for the specific room
    setSelectedAdults(newSelectedAdults);

    BookingDetailsService.amount_calculation(
      singleRoom.arrival_date,
      singleRoom.departure_date,
      singleRoom.rooms[0].roomTypeId,
      transformedData
    )
      .then((res) => {
        if (res?.data?.status?.code === 0) {
          let calculatedTotal = 0;
          let calculatedGstCharge = 0;
          res?.data?.data?.slice(0, -1).forEach((item) => {
            item?.detail?.forEach((detailItem) => {
              const roomCharge = detailItem?.roomCharge;
              if (typeof roomCharge === "number") {
                calculatedTotal += roomCharge;
              }
            });
          });
          // setTableCalucation(res?.data?.data);
          // console.log(res?.data?.data);

          res?.data?.data?.slice(0, -1).forEach((item) => {
            item?.detail?.forEach((detailItem) => {
              const gst = detailItem?.gst;
              if (typeof gst === "number") {
                calculatedGstCharge += gst;
              }
            });
          });
          console.log(calculatedTotal, calculatedGstCharge);
          setTotalRoomCrtCharge(calculatedTotal);
          setTotalGstCrtCharge(calculatedGstCharge);
          setTotalPayableCrtAmount(calculatedTotal + calculatedGstCharge);
        } else {
          console.log("ERROR MESSAGE", res.data.status.message);
        }
      })
      .catch((error) => {
        console.log("Errorreg", error);
      });
  };

  useEffect(() => {
    // getBookingHistory();
    setcurrent(1);
  }, []);

  useEffect(() => {
    getBookingHistory();
  }, [current]);

  useEffect(() => {
    const roomCharge = cartData?.data?.reduce((total, data) => {
      return total + (data?.roomCharge || 0);
    }, 0);
    const taxGst = cartData?.data?.reduce((total, data) => {
      return total + (data?.gst || 0);
    }, 0);
    const total = roomCharge + taxGst;
    console.log(roomCharge, taxGst, total, "kuhfasduifhaushf");
    setCalculatedRoomCharge(roomCharge);
    setCalculatedTaxgst(taxGst);
    setCalculatedTotalAmt(Number(total.toFixed(2)));

    // console.log(calculatedTotalAmt);
  }, [cartData]);

  /**
   * get booking history
   */
  const getBookingHistory = () => {
    setLoader("loading");
    MyAccountService.getCartItems(user_id, current)
      .then((res) => {
        if (res?.data?.status?.code === 0) {
          setPageCount(res?.data?.data?.totalPages);
          console.log(res?.data, "jdkshgsdfhg");
          const totalGST = res?.data?.data?.reduce((sum, item) => {
            return sum + (item.gst || 0);
          }, 0);
          const totalRoomCharge = res?.data?.data?.reduce((sum, item) => {
            return sum + (item.roomCharge || 0);
          }, 0);
          setTotalingGst(totalGST);
          setTotalingRoomCharge(totalRoomCharge);
          setCartData(res?.data);

          // console.log(res?.data, res?.data.data.length, "hyhhhhhh");
          let selectedBookingIds = [];

          if (Array.isArray(res?.data?.data) && res?.data?.data.length > 1) {
            selectedBookingIds = res?.data?.data
              .slice(1)
              .flatMap(
                (item) => item.rooms?.map((room) => room.bookingId) || []
              );

            // console.log("Selected Booking IDs:", selectedBookingIds);
            // for (const id of selectedBookingIds) {
            MyAccountService.deleteCartBooking(
              selectedBookingIds,
              res?.data?.data?.[0].cartId
            )
              .then((res) => {
                if (res?.data?.status?.code === 0) {
                  setPageCount(res?.data?.data?.totalPages);
                  setRemoveRooms(false);
                  getBookingHistory();
                  // dispatch(
                  //   alertActions.success("Booking deleted successfully")
                  // );
                  window.location.reload();
                } else {
                  setLoader("isfull");
                  setRemoveRooms(false);
                  dispatch(alertActions.error(res?.data?.status?.message));
                }
              })
              .catch((error) => {
                setLoader("isfull");
                setRemoveRooms(false);
                console.log("Error:", error);
              });
            // }
          }

          console.log(res?.data);
          setLoader("isfull");
        }
      })
      .catch((error) => {
        setLoader("isfull");
        console.log("Errorreg", error);
        dispatch(alertActions.error(error));
      });
  };

  const goBack = () => {
    navigate(-1);
  };

  const viewdeails = (listss, list) => {
    setSingleViewDetails(listss);
    setSingleRoom(list);
    console.log(list, "hdjsahdjashd", listss);
    setViewDetails(true);
    const dddddd = calculateDifference(list.arrival_date, list.departure_date);
    const adultsArray = list?.rooms
      ?.filter((room) => room.roomTypeId === listss.roomTypeId)
      ?.map((filteredRoom) => filteredRoom.adults);

    const filteredArray = adultsArray?.filter(
      (_, index) => index % dddddd === 0
    );

    const childrenArray = list?.rooms
      ?.filter((room) => room.roomTypeId === listss.roomTypeId)
      ?.map((filteredRoom) => filteredRoom?.infants?.length);

    const filteredArray1 = childrenArray?.filter(
      (_, index) => index % dddddd === 0
    );

    const childrenArrayAbove = list?.rooms
      ?.filter((room) => room.roomTypeId === listss.roomTypeId)
      ?.map((filteredRoom) => filteredRoom?.infantsAbove8?.length);

    const filteredArray2 = childrenArrayAbove?.filter(
      (_, index) => index % dddddd === 0
    );

    setSelectedAdults(filteredArray);
    console.log("filteredArray", filteredArray, filteredArray1);

    setSelectedChildren(filteredArray1);
    setSelectedChildrenAbove8(filteredArray2);
  };

  const closeModal = () => {
    setViewDetails(false);
    setRemoveRooms(false);
  };

  const saveCartUpdate = () => {
    // console.log(roomChangeSelectedValue, roomSelectedIndex);
    // console.log(extractedData, "extractedData");

    BookingDetailsService.updateCartRooms(extractedData)
      .then((res) => {
        if (res?.data?.status?.code === 0) {
          setRemoveRooms(false);
          setLoader("isfull");
          setcurrent(1);
          getBookingHistory();
          dispatch(alertActions.success(res.data.status.message));
        } else {
          setLoader("isempty");
          dispatch(alertActions.error(res.data.status.message));
        }
      })
      .catch((error) => {
        console.log("Errorreg", error);
      });

    // console.log(extractedData.length / extractedData[0].no_of_room, "NoOfDays");
  };

  const editRooms = (listss, list) => {
    // console.log(list, "hdjsahdjashd");
    setSingleViewDetails(listss);
    setSingleRoom(list);
    console.log(list, "husjgfersg");
    setRemoveRooms(true);
    const dddddd = calculateDifference(list.arrival_date, list.departure_date);
    const adultsArray = list?.rooms
      ?.filter((room) => room.roomTypeId === listss.roomTypeId)
      ?.map((filteredRoom) => filteredRoom.adults);

    const filteredArray = adultsArray?.filter(
      (_, index) => index % dddddd === 0
    );

    const childrenArray = list?.rooms
      ?.filter((room) => room.roomTypeId === listss.roomTypeId)
      ?.map((filteredRoom) => filteredRoom?.infants?.length);

    const filteredArray1 = childrenArray?.filter(
      (_, index) => index % dddddd === 0
    );

    const childrenArrayAbove = list?.rooms
      ?.filter((room) => room.roomTypeId === listss.roomTypeId)
      ?.map((filteredRoom) => filteredRoom?.infantsAbove8?.length);

    const filteredArray2 = childrenArrayAbove?.filter(
      (_, index) => index % dddddd === 0
    );

    setSelectedAdults(filteredArray);
    setSelectedChildren(filteredArray1);
    setSelectedChildrenAbove8(filteredArray2);

    setExtractedData(
      singleRoom?.rooms?.map(
        ({ adults, bookingId, roomTypeId, room_type, infantsUnder8 }) => ({
          adults,
          bookingId,
          roomTypeId,
          room_type,
          infantsUnder8,
        })
      )
    );
    // console.log(extractedData, "extractedData");
  };

  const closeOpenNew = () => {
    setViewDetails(false);
    setRemoveRooms(true);
  };

  const addMoreRooms = () => {
    navigate("/");
  };

  /**
   * page change
   * @param {} e
   */
  const changeCurrentPage = (page) => {
    setcurrent(page.selected + 1);
  };
  /**
   * handle change
   * @param {*} e
   */
  // const handleChangeName = (e) => {
  //   setFullName(e.target.value);
  // };
  // const handleChangeEmail = (e) => {
  //   setEmail(e.target.value);
  // };

  /**
   * navigate to booking
   */
  const navigateToBook = () => {
    navigate("/");
  };

  // const handleUpdateStatus = (e) => {
  //   setEditing(true);
  // };

  // const deleteBooking = (item) => {
  //   setLoader("loading");
  //   MyAccountService.deleteCartBooking(item.bookingId, item._id)
  //     .then((res) => {
  //       if (res?.data?.status?.code === 0) {
  //         setPageCount(res?.data?.data?.totalPages);
  //         getBookingHistory();
  //         dispatch(alertActions.success(res?.data?.status?.message));
  //         setLoader("isfull");
  //       } else {
  //         setLoader("isfull");
  //         dispatch(alertActions.error(res?.data?.status?.message));
  //       }
  //     })
  //     .catch((error) => {
  //       setLoader("isfull");
  //       console.log("Errorreg", error);
  //     });
  // };

  const calculateDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = end - start;
    return diffTime / (1000 * 60 * 60 * 24);
  };

  const formatDateRangessss = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const options = { day: "numeric", month: "long", year: "numeric" };
    const formattedStart = start.toLocaleDateString("en-GB", options);
    const formattedEnd = end.toLocaleDateString("en-GB", options);
    const startDay = start.getDate();
    const endDay = end.getDate();
    const startMonth = start.toLocaleString("default", { month: "long" });
    const endMonth = end.toLocaleString("default", { month: "long" });
    const startYear = start.getFullYear();
    const endYear = end.getFullYear();
    if (startMonth === endMonth && startYear === endYear) {
      return `${startDay} to ${endDay} ${startMonth} ${startYear}`;
    } else if (startYear === endYear) {
      return `${startDay} ${startMonth} to ${endDay} ${endMonth} ${startYear}`;
    } else {
      return `${formattedStart} to ${formattedEnd}`;
    }
  };

  const makePayment = (e) => {
    // console.log("Bulk Payment Entered", cartData);
    e.preventDefault();
    setLoader("loading");
    mydata = [];
    // console.log(cartData?.data?.docs, "BookingIdCollection");
    // cartData?.data?.docs.map((data) => mydata.push(data?.bookingId));
    if (Array.isArray(cartData?.data)) {
      cartData.data.forEach((data) => {
        if (Array.isArray(data?.rooms)) {
          data.rooms.forEach((room) => {
            if (room?.bookingId) {
              mydata.push(room.bookingId);
            }
          });
        }
      });
    }
    BookingDetailsService.specialRequestAdd(request).then((res) => {
      if (res?.data?.status?.code === 0) {
        // dispatch(alertActions.success(res?.data?.status?.message));
        // localStorage.setItem("cartNotLoggedIn", "");
      } else {
        // dispatch(alertActions.error(res?.data?.status?.message));
        // window.location.reload();
      }
    });
    BookingDetailsService.getBooking(mydata).then((res) => {
      if (res?.data?.status?.code === 0) {
        if (res?.data?.data?.[0]?.booking_status === 1) {
          setLoader("loading");
          BookingDetailsService.makeBulkPayment(
            calculatedTotalAmt,
            mydata,
            cartData?.data?.[0].cartId
          )
            .then((res) => {
              if (res?.data?.status?.code === 0) {
                displayRazorpay(res?.data, mydata);
                setLoader("isfull");
              } else {
                setLoader("isempty");
                dispatch(alertActions.error(res.data.status.message));
                console.log("ERROR MESSAGE", res.data.status.message);
              }
            })
            .catch((error) => {
              console.log("Errorreg", error);
            });
        }
      }
    });
  };

  const changedate = (date1, date2) => {
    let arr = date1.split("-");
    let arr2 = new Date(arr[0], arr[1] - 1, arr[2]);
    let arr1 = date2.split("-");
    let arr4 = new Date(arr1[0], arr1[1] - 1, arr1[2]);
    let diffInMs = Math.abs(arr4 - arr2);
    return diffInMs / (1000 * 60 * 60 * 24);
  };
  return {
    cartData,
    loader,
    // loading,
    editing,
    pageCount,
    current,
    calculatedRoomCharge,
    calculatedTaxgst,
    calculatedTotalAmt,
    user_name,
    user_email,
    user_phone,
    viewDetails,
    removeRooms,
    user_id,
    singleViewDetails,
    singleRoom,
    totalingRoomCharge,
    totalingGst,
    selectedAdults,
    extractedData,
    totalRoomCrtCharge,
    totalGstCrtCharge,
    totalPayableCrtAmount,
    request,
    selectedChilren,
    selectedChilrenAbove8,
    handleChangeRequest,
    handleChangeRooms,
    deleteCartRoom,
    changedate,
    navigateToBook,
    makePayment,
    changeCurrentPage,
    // deleteBooking,
    goBack,
    viewdeails,
    closeModal,
    editRooms,
    addMoreRooms,
    closeOpenNew,
    calculateDifference,
    formatDateRangessss,
    saveCartUpdate,
    handleChangeChildren,
  };
};
export default useCartPage;
